$(document).ready(function(){
    //skipbins slick slider on homepage
    $('.skipbins-slider').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       dots: true,
       arrows: false,
       // focusOnSelect: true,
       autoplay: true,
       autoplaySpeed: 10000,
       responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 10000
              }
            }
        ]
    });
    
    $('.slick-slider').each(function() {
        var $this = $(this);
        if ($this.find('.slick-track').children().length <= 1) {
            $this.next('.btn-controls').hide(); //hide prev/next button if slider have 1 or less item
        }
    });

    $('.slick-slider').each(function() {
        var $this = $(this);
        if ($this.find('.slick-track').children().length <= 1) {
            $this.next('.btn-controls').hide(); //hide prev/next button if slider have 1 or less item
        }
    });

    $('.right-skipbins .icon-arrow-left').click(function(){
        $(".skipbins-slider").slick('slickPrev');
    });

    $('.right-skipbins .icon-arrow-right').click(function(){
        $(".skipbins-slider").slick('slickNext');
    });

    //External slick buttons on desktop when on click active color change
    $('.skipbins-nav a[data-slide]').click(function(e) {
       e.preventDefault();
       var slideno = $(this).data('slide');
       $('.skipbins-nav a.active').removeClass('active');
       $('.skipbins-slider').slick('slickGoTo', slideno - 1);
       $(this).addClass('active');
       
    });

    //Autoplay external slick buttons on desktop autochange
    $('.skipbins-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.skipbins-nav a.active').removeClass('active');
        $('.skipbins-nav a').eq(nextSlide).addClass('active');
    });

    //Smartskip Slick Slider
    $('.smartskip-slider .icon-arrow-left').click(function(){
        $(".smartskip-slider__details").slick('slickPrev');
    });

    $('.smartskip-slider .icon-arrow-right').click(function(){
        $(".smartskip-slider__details").slick('slickNext');
    });

     $('.smartskip-slider__details').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        asNavFor: '.smartskip-slider__text',
        autoplay: true,
        autoplaySpeed: 10000
     });
     $('.smartskip-slider__text').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.smartskip-slider__details',
        dots: false,
        fade: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000
        // cssEase: 'ease-in-out',
        // adaptiveHeight: true
     });

     $('a[data-slide]').click(function(e) {
       e.preventDefault();
       var slideno = $(this).data('slide');
       $('.smartskip-slider__text').slick('slickGoTo', slideno - 1);
     });

    if($('.smartskip-slider__details--list').length <= 1){
        $(".smartskip-slider .btn-controls, .smartskip-slider__details .slick-dots").addClass("d-none");
    }
    
    //fix issue with autoplay on mobile
    $('.skipbins-slider').on('touchcancel touchmove', e => {
          $('.skipbins-slider').slick('slickPlay');
    });
    $('.smartskip-slider__details').on('touchcancel touchmove', e => {
          $('.smartskip-slider__details').slick('slickPlay');
    });
    $('.smartskip-slider__text').on('touchcancel touchmove', e => {
          $('.smartskip-slider__text').slick('slickPlay');
    });
    //End Smartskip Slick Slider

    $(".multiple-slider-profile").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 4, 
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
                
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }

        ]
    });


    $('.profile-template .icon-arrow-left').click(function(){
        $(".multiple-slider-profile").slick('slickPrev');
    });

    $('.profile-template .icon-arrow-right').click(function(){
        $(".multiple-slider-profile").slick('slickNext');
    });
    //new Investor hub
    $('.multiple-slider-investor').slick({
        autoplay: false,
        infinite: true,
        arrows: false,
        dots: false,
        slidesToShow: 1, 
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                dots: false
              }
            }
        ]
    });

    $('.update-control__prev').click(function(){
        $(".multiple-slider-investor").slick('slickPrev');
    });

    $('.update-control__next').click(function(){
        $(".multiple-slider-investor").slick('slickNext');
    });
    
    //BOOTSTRAP MENU
    $("#site-navigation ul.sub-menu").parent().addClass("dropdown");
    $("#site-navigation ul.sub-menu").addClass("dropdown-menu dropdown-menu-left");
    $("#site-navigation ul#menuid li.dropdown a").addClass("dropdown-toggle");
    $("#site-navigation ul.sub-menu li a").removeClass("dropdown-toggle");
    $('#site-navigation .navbar .dropdown-toggle').append('');
    $('#site-navigation a.dropdown-toggle').attr('data-toggle', 'dropdown');
    //$('#site-navigation .dropdown > a').append('<span class="caret"></span>');
    $('<span class="caret"></span>').appendTo('#site-navigation .dropdown > a');

    
    //TRUNCATE WORDS
    var longParagraphs = document.querySelectorAll('[data-truncate]');

    Array.prototype.forEach.call(longParagraphs, function(el, i){
      var amount = parseInt(el.getAttribute('data-truncate')),
          words = el.textContent.split(' '),
          lessWords = words.splice(0, amount).join(' ');

      el.textContent = lessWords;
    });
    
    jQuery( "#btn-advanced" ).click(function() {
       jQuery( "#search-advance" ).slideToggle( "slow" );
    });
    
    //MEGAMENU
    $(".submenu-content__right").first().addClass('active'); // show first subcategories
    $(".submenu-content__left a").first().addClass('active');
    $(".submenu-content__left a").click(function(){
        var divId= $(this).data('id');
        $(".submenu-content__right").removeClass('active');
        $(".submenu-content__right#"+divId).addClass('active');
        $(".submenu-content__left a").removeClass('active');
        $(this).first().addClass('active');
    });
    //MEGAMENU
    
//DUMMY JS FOR MEGAMENU
    $("#contact-us").insertAfter($(this).find('#site-navigation .contactus_menu').find('a:first'));

    
//DUMMY JS FOR MEGAMENU

//function: get forms by class
$('.form-request-a-qoute').on('click', function (e) {
  $('.modal-request-a-qoute').modal();

});

$('.form-general').on('click', function (e) {
  $('.modal-general-enquiries').modal();

});

$('.form-book-a-service').on('click', function (e) {
  $('.modal-book-a-service').modal();

});





    //start-of-function for sticky hiring button on careers page
    function sticktothetop() {
        var window_top = $(window).scrollTop();
        var top = $('#btn-sticky-here').offset().top;
        if (window_top > top) {
            $('#btn-sticky').addClass('stick');
            $('#btn-sticky-here').height($('#btn-sticky').outerHeight());
        } else {
            $('#btn-sticky').removeClass('stick');
            $('#btn-sticky-here').height(0);
        }
    }

    if ($(".careers, .careers-inner, .single-sustainable-future")[0]){
        $(window).scroll(sticktothetop);
        sticktothetop();
    }
    //end-of-function for sticky hiring button on careers page
    
    //To open at least one accordion tab at a time
//    $('.panel-heading a').on('click',function(e){
//        if($(this).parents('.panel').children('.panel-collapse').hasClass('in')){
//            e.stopPropagation();
//        }
//    });
    
    //confirm dialog box
    $('[name="confirm-delete"]').on('click', function(e) {
        var $form = $(this).closest('form');
        e.preventDefault();
        $('#confirm-delete-modal').modal({
          backdrop: 'static',
          keyboard: false
        })
      .on('click', '#delete', function(e) {
          $form.trigger('submit');
        });
    });
    
    //Tiles resize
    $('.solutions.solutions-industry .square__more').on('click', function () {
        $('.solutions.solutions-industry .square__link').toggleClass('col-md-4 col-md-3');
        $('.solutions.solutions-industry').addClass('showAll');
        $(this).hide();
    });
    
    $('.solutions.solutions-services .square__more').on('click', function () {
        $('.solutions.solutions-services .square__link').toggleClass('col-md-4 col-md-3');
        $('.solutions.solutions-services').addClass('showAll');
        $(this).hide();
    });


    // jQuery('#myTable').DataTable();
    //jQuery('#myTable').DataTable({searching: true, paging: true, info: true});


    //SFH Diagram
    // $('#sfh-illustration #tabs-sfh li').click(function() {
    //     var sfh_number = $(this).index();
    //     var tabs_content = $('.tabs-desc').addClass('fade-out').hide();

    //     tabs_content.eq(sfh_number).removeClass('fade-out').show();
    //     $('.sfh__box').hide().eq(sfh_number).show();
    //     $(this).toggleClass('active inactive');
    //     $('#sfh-illustration #tabs-sfh li').not(this).removeClass('active').addClass('inactive');
    // });

    // $('#sfh-illustration .tabs-desc').not(':first').hide();
    // $('#sfh-illustration .sfh__box').not(':first').hide();
    
    //Open a modal upon option selection for need a skip
    $('#SkipSelect').change(function() { //jQuery Change Function
        var oplink = $('option:selected').attr("data-link");//Get value from select element
        var opval = $(this).val();
        if(oplink){ //Compare it and if true
            document.location.href = oplink;
        } else{
            $('#booking'+opval).modal("show"); //Open Modal
        }
    });
    
    //My Statement Explained and My Bill Explained
    if ($('.page-template-my-bill-explained-page').length > 0 || $('.page-template-my-statement-explained-page').length > 0) {
        // console.log('.page-template-mybillexplained and .page-template-mystatementexplained exist');
        $("[data-toggle=popover]").popover({
          trigger: 'focus',
          html: true,
          content: function() {
            var id = $(this).attr('id');
             // console.log('start' + '#' + id);
            return $('#popover-content-' + id).html();
          },
          callback: function() {
             // add and remove .active
            $('body').on('click', function (e) {
                var id = $(e.target).attr('id');
                var aria = $(e.target).attr('aria-describedby');

                $('body').on('click touchstart', '.popover', function(e) {
                    //console.log("clicked inside popover")
                    if ($(e.target).is('.closePop')) {
                        unset();
                        $(this).popover('hide');

                    } else{
                        e.preventDefault();
                    }

                });

                $(".clickPopover").each(function() {
                   //console.log('.popover' + '#' + id);
                    if (!$(e.target).is("active") && $(e.target).closest('.popover' + '#' + aria).length == 0 && $(e.target).hasClass('clickPopover')) {
                        //$('#'+id).popover('show');
                        $('#'+id).addClass('active');
                    } else if (!$(e.target).is('.active')) {
                        if ($(e.target).is('.popover *')) {
                            //$(e.target).popover('show');
                        } else{
                            $(this).removeClass('active');
                            $(this).popover('hide');
                        }

                    }
                });
            });
          }
        })
        .on('show.bs.popover', function(shownEvent) {
            $(".clickPopover").each(function() {
                $(this).removeClass('active');

            });
        });

        var tmp = $.fn.popover.Constructor.prototype.show;
        $.fn.popover.Constructor.prototype.show = function () {
          tmp.call(this);
          if (this.options.callback) {
            this.options.callback();
          }
        }

        function unset(){
             $("[data-toggle=popover]").each(function(i, obj) {
                $(this).removeClass('active');
             })
        }
    }
    
    //ribbon on top of the page
   $( ".closeribbon" ).click(function() {
       $( ".ribbon" ).slideToggle( 300 );
   });
    
    //Daniels health logo for the menu
    $( ".submenu-content__title:contains('Health and Clinical')" ).prepend( "<span class='icon-cleanawaydaniels'></span>" );
    
    //stop the video if modal box is closed
    $("#modal-video-newsroom.modal").on('hidden.bs.modal', function (e) {
        $("#modal-video-newsroom.modal iframe").attr("src", $("#modal-video-newsroom.modal iframe").attr("src"));
    });
    
    $(".catbutton__wrapper--mobile select").each(function() {
        if ( $('option', this).length > 1 ) 
            $(this).show();
    });
    
    //scroll to top button
    $(".button-scroll-up").click(function() {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    });
    
    window.onscroll = function() { scrollButtonFunction() };
    
    function scrollButtonFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        $(".button-scroll-up").css("display","flex");
        } else {
        $(".button-scroll-up").css("display","none");
        }
    }

    //RNW PAGE
    var articles_show = 3;
    var articles_count = $('.articles_count').val();
    //Button show more article
    if (articles_count >= 1) {
        $('.related-article').slice(0, 3).removeClass('hidden');
    }
    if (articles_count <= 3) {
        $('.btn-readmore').addClass('hidden');
    }

    $(".btn-readmore-articles").on('click', function() {
        articles_show += 3;
        $('.related-article').slice(0, articles_show).removeClass('hidden');

        if (articles_show >= articles_count ) {
            $('.btn-readmore').addClass('hidden');
        }

    });
    //video popup
    $(".video-pop-up").click(function() {
        var getUrlVideo = $(this).find("iframe").attr("src");
        $("#modal-video-newsroom").find("iframe").attr("src", getUrlVideo);
        $("#modal-video-newsroom").modal("show");
    });

    //Carousel animation
    var number_slide = $('.carouselnrw__item').length - 1;
    var slide_first = $('.carouselnrw__item').first().attr("data-slide");
    $("#myCarousel1").on('slide.bs.carousel', function(evt) {
        var current_img = $(this).find('.active').attr("data-slide");
        var current_slide_id = $(this).find('.active').index();
        //var slideTo = $(evt.relatedTarget).index();
        //var slide_To_Img = $('.carouselnrw__item').eq(slideTo).attr("data-slide");

        if (current_slide_id != number_slide) {
            $("#myCarousel1").css("background-image", "url(" + current_img + ")");
        }else{
            $("#myCarousel1").css("background-image", "url(" + slide_first + ")");
        }

        

    })
    //END RNW PAGE

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        load_delay: 300,
        threshold: 0
    });
    
    //IE fixes for need a skip hover
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
        $('.blocks__skip .blocks:first-child .custom-dropdown__select').focus(
           function(){ $('.blocks__skip .blocks:first-child').addClass('hover') }
           //function(){ $('.blocks__skip .blocks:first-child').removeClass('hover') }
        )
        $('.blocks__skip .blocks:first-child .custom-dropdown__select').blur(
           //function(){ $('.blocks__skip .blocks:first-child').addClass('hover') },
           function(){ $('.blocks__skip .blocks:first-child').removeClass('hover') }
        )
    }

    //Location about us images slider
    $('.about-us__img').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        touchMove: true,
        responsive  : [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            }
        ]
    });

    if($('.about-us__img .item-image').length <= 4){
        $(".about-us__img .slick-dots").addClass("hidden");
    }

    //Button controls of location about us image
    $('.btn-controls__prev').click(function() {
        $(".about-us__img").slick('slickPrev');
    });

    $('.btn-controls__next').click(function() {
        $(".about-us__img").slick('slickNext');
    });


    //Service Nearby mobile if more than 2 column
    $('.service-nearby__column').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        arrows: false,
        touchMove: true,
    });

    //Location Accepted Waste Sub Tabs Images when viewed on mobile
    $('.blocks-img__mobile').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        infinite: true,
        arrows: false,
        touchMove: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            }
        ]
    });

    if($('.blocks-img__mobile').length <= 2){
        $(".blocks-img__mobile .slick-dots").addClass("hidden");
    }

    function toggleIcon(e) {
        $(e.target)
            .prev('.panel-heading')
            .find(".plus-minus")
            .toggleClass('icon-plus icon-minus');
    }
    $('.panel-group .location-sub-panel').on('hidden.bs.collapse', toggleIcon);
    $('.panel-group .location-sub-panel').on('shown.bs.collapse', toggleIcon);
});

//service area > request a quite modal box
$(document).on('show.bs.modal', '#modal-1', function () {
        $('#service-area').modal('hide');
        window.setTimeout(function(){
            $("body").addClass("modal-open");
        }, 1000);
});

//Thank you for visiting our beta site.
//if(localStorage.getItem('popupthank') != 'shown'){
//    setTimeout(function () {
//        $('#ribbon').modal('show');
//    }, 30000);
//    localStorage.setItem('popupthank','shown'); 
//}
$('#closepopupads').click(function(e){ 
    $('#ribbon').fadeOut(); 
});


/* $(".hasDatepicker").on("blur", function(e) 
    { $(this).off("focus").datepicker("hide"); });*/

if ($('#contact-us').length > 0) {
    $(document).ready(function(){
        $('li:nth-child(1) > b').hover( function() {
            $('li:nth-child(1) > b').css("text-decoration", "underline"); 
            $('li:nth-child(1) > b').css("cursor", "pointer"); 
        });
        $('li:nth-child(1) > b').click( function() {
            $('.detail').css("display", "block"); 
        });
        $(".icon-close").click(function(){
            $('.detail').css("display", "none"); 
            $("li:nth-child(1) > b").css("text-decoration", "none");    
        });
        $( "#contact-us" ).mouseleave(function() {
            $('.detail').css("display", "none");
            $("li:nth-child(1) > b").css("text-decoration", "none");     
        });
        $( "li:nth-child(1) > b" ).mouseleave(function() {
            $("li:nth-child(1) > b").css("text-decoration", "none");     
        });
        $('.footer-contactus__number--popup').click(function() {
            $('.detail--footer').css('display', 'block');
        });
        $('.detail--footer').find('.icon-close--footer').unbind('click').click(function() {
            $('.detail--footer').css('display', 'none');
        });
        $( ".footer" ).mouseleave(function() {
            $('.detail--footer').css('display', 'none');
        });
    });

    //fix form re-submitted when click browser go back contact-us page
    $(document).on('gform_post_render', function(e, form_id){
        if($('#contact_form_id').length > 0){
            if(form_id == $('#contact_form_id').val()){
                $('#gform_ajax_frame_'+form_id).attr('src', 'about:blank');
            }
        }
    });
}

jQuery(document).ready(function(){
    jQuery(".menu-item-object-product_cat").click( function() {
        jQuery(".menu-item-object-product_cat").removeClass("current-menu-item");
        jQuery(this).addClass("current-menu-item");
    });

    jQuery("#search-input").on("keyup", function() {
    var value = jQuery(this).val().toLowerCase();
    jQuery("#stateSuburb li").filter(function() {
      jQuery(this).toggle(jQuery(this).text().toLowerCase().indexOf(value) > -1)
    });

    var check_li_visible = jQuery("#stateSuburb li:visible").length;

    if (check_li_visible == 0) {
        jQuery(".text_result").removeClass("hide");
    }else{
        jQuery(".text_result").addClass("hide");
    }


    
    });
    $('.search_input_header[type=search]').on('search', function () {
        $(".text_result").addClass("hide");
        $("#stateSuburb li").toggle("show");
    });

});

$("#search-input").on("click input change keydown paste", function(){
	    // Check if input has value then hide search icon
	    if($(this).val()) {
	        $('.icon-search').hide();
	    } else {
	        $('.icon-search').show();
	    }
});